import { ORDER_INFO_LOADED } from 'src/constants/order';

export function orderInfoLoaded({ order }) {
  return {
    type: ORDER_INFO_LOADED,
    payload: { order }
  };
}
